import { render, staticRenderFns } from "./PuzzleRow.vue?vue&type=template&id=802842c4"
import script from "./PuzzleRow.vue?vue&type=script&lang=js"
export * from "./PuzzleRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports